import { DatePipe, formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isDate } from 'date-fns';

@Pipe({
  name: 'standardTime',
})
export class StandardTimePipe extends DatePipe implements PipeTransform {
  // @ts-ignore
  public transform(value: any, format?: string, timezone?: string, locale?: string): string | null {
    if (!value) {
      return '—';
    }
    return super.transform(value, standardTimeFormat(value));
  }
}

export function standardTimeFormat(value: any): string {
  const timezone = /.*\s(.+)/.exec(new Date().toLocaleDateString(navigator.language, { timeZoneName: 'short' }))[1];

  const formattingText = `h:mmaaaaa'm' '${timezone}'`;
  return formattingText;
}

export function formatTimeStandard(value: any): string {
  if (!isDate(value)) {
    value = new Date(value);
  }
  const formatStr = standardTimeFormat(value);
  return formatDate(value, formatStr, 'en-US');
}
